module.exports = __webpack_public_path__ + "static/media/jet-is-wrong.b05a7212.mp3";